import Vue from 'vue'
import getInputsValue from "./common/getInputsValue"

function getInitState() {
  return {
    inputs: {
      name: {
        value: null
      },
      surname: {
        value: null
      },
      birthday: {
        value: null
      },
      gender: {
        value: null
      },
      citizenship: {
        value: null
      },
      international_passport_series: {
        value: null
      },
      international_passport_number: {
        value: null
      },
      international_passport_creation_date: {
        value: null
      },
      international_passport_expired_date: {
        value: null
      },
    }
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
  },
  actions: {},
  getters: {
    formData(state) {
      const data = getInputsValue(state.inputs)

      return data
    }
  }
}
